<div class="mainLoader" *ngIf="loading==true">
  <div class="loader"></div>
</div>
<div class="mainLoader" *ngIf="rememberService.isLoading">
  <div class="loader"></div>
</div>
<div class="loginModule" [ngClass]="popup ? 'autoHeightWidth' : 'noautoHeightWidth'">
  <div class="loginWrapper">
    <div class="loginWrapperLeft">
      <a href="/" class="loginLogo"><img src="../../assets/logoSmall.svg" /></a>
      <h3>Sign In</h3>

      <div class="choicetoLogin" style="margin-top:20px;">
        <label [ngClass]="loginWithOtp == false ? 'choicetoLoginSelected' : ''" style="margin-right:2px;">
          <input type="radio" title="Email" value="Email" id="Email" class="radioChoice" name="loginWithOtp" (change)="radioChange($event)" checked />
          <span for="Email">Email</span>
        </label>
        <label [ngClass]="loginWithOtp == true ? 'choicetoLoginSelected' : ''" for="Phone">
          <input type="radio" title="Phone number" value="Phone" id="Phone" class="radioChoice" name="loginWithOtp" (change)="radioChange($event)" />
          <span for="Phone">Phone Number</span>
        </label>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" *ngIf="loginWithOtp == false">
        <div class="form-group">
          <label for="email" class="form-label">Email AddRess</label>
          <input type="email" class="form-control" id="email" placeholder="" formControlName="email"
                 [ngClass]="{'invalid': submitted && f['email'].invalid}" />
          <div *ngIf="submitted && f['email'].invalid">
            <p style="color: red;">
              Please provide a valid Email.
            </p>
          </div>
        </div>
        <!-- {{submitted}} -->
        <div class="form-group">
          <label for="password" class="form-label">PASSWORD</label>
          <div class="position-relative">
            <!-- {{f['password'].errors['min']| json}} -->
            <input [type]="fieldTextType ? 'text' : 'password'" class="form-control" formControlName="password" [ngClass]="{'invalid': submitted && f['password'].invalid}" />
            <div *ngIf="submitted && f['password'].invalid">
              <p style="color: red;">
                Password should be 6 charecter long.
              </p>
            </div>
            <button type="button" (click)="toggleChild()" class="pwd_btn">
              <img src="{{ showVar ? '../../assets/ic_eye_hide.png' : '../../assets/ic_eye_show.png'}}" />
            </button>
          </div>
        </div>
        <!--<div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" formControlName="rememberMe">
          <label class="form-check-label form-label" for="flexCheckDefault">
            Remember me
          </label>
        </div>-->

        <div class="buttonGroup d-grid">
          <button type="submit" class="btn btn-secondary w-100">Sign In</button>
          <hr />
        </div>
      </form>
      <form *ngIf="loginWithOtp == true">
        <div class="form-group">
          <label for="phone" class="form-label">Phone number</label>
          <a *ngIf="changeMobile==true" style="cursor:pointer; margin-left:5px;" (click)="changeMob()" href="javascript:void(0)">Change</a>
          <div class="position-relative">
            <!--<span class="phone_prefix">+</span>-->
            <!--<img src="../../assets/images/plusPhone.svg" class="phone_prefix"/>-->
            <input *ngIf="changeMobile==false" type="text"
                   style="padding-left:1.5rem" class="form-control"
                   [(ngModel)]="phonenumber" name="phonenumber" id="phone" placeholder="" maxlength="14" />
            <input *ngIf="changeMobile==true" disabled type="text"
                   style="padding-left:1.5rem" class="form-control"
                   [(ngModel)]="phonenumber" name="phonenumber" id="phone" placeholder="" maxlength="14" />
          </div>
        </div>
        <div class="form-group" *ngIf="enterOtp==true">
          <label for="OTP" class="form-label">OTP</label>
          <input type="text" class="form-control" [(ngModel)]="otp" name="otp" maxlength="6" id="OTP" placeholder="" />

        </div>
        <label class="font_12 color_grey_light" *ngIf="enterOtp==true">Didn't receive OTP? <span *ngIf="displayTimer != '00:00'">Resend in {{displayTimer}}</span><a *ngIf="resendOTP==true" href="javascript:void(0)" style="cursor:pointer" (click)="resendOTPClick()">Resend OTP</a></label>
        <div class="buttonGroup d-grid">
          <label class="form-label" *ngIf="enterOtp==false">By clicking on Get OTP, you agree to receive a text message from us to verify your identity for login purposes. Standard messaging rates may apply.</label>
          <button type="submit" (click)="getotp()" class="btn btn-secondary w-100" *ngIf="enterOtp==false">Get Otp</button>
          <button type="submit" (click)="validateotp()" class="btn btn-secondary w-100" *ngIf="enterOtp==true">Sign In</button><hr />

        </div>
      </form>
      <div class="buttonGroup d-grid" *ngIf="!popup">

        <button type="button" class="btn btn-light  w-100" (click)="signup()">Create Account</button>
      </div>

    </div>
    <div class="loginWrapperRight d-none d-sm-inline-flex">
      <figcaption>
        <h1 class="font_med">Welcome to PharmaVision</h1>
        <h5>
          AI based one stop shop for capture, vet, and distributing insights in real-time
        </h5>
      </figcaption>
    </div>
  </div>
  <p class="forgotPassword mt-3" *ngIf="!popup">
    Forgot your password? <a href="javascript:void(0)" [routerLink]="['/forgot-password']">Get a new password</a>
  </p>
</div>
<!--</ng-template>-->
